/* eslint-disable */
import React, { useState } from 'react'
import { makeStyles, withStyles } from '@material-ui/core'
import Tooltip from '../../../atoms/Tooltip'
import SydSelect from '../../../commonDesign/SydSelect'
import SydButton from '../../../commonDesign/Button'
import SydLabel from '../../../commonDesign/SydLabel'
import { options } from '../quickDatePicker'
import { useVariables } from '../../../../providers/VariableProvider'
import PropTypes from 'prop-types'
import SydInput from '../../../commonDesign/SydInput'
const useStyles = makeStyles(() => ({
    container: {
        height: '450px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        gap: '.5rem'
    },
    QDContainer: {
        width: '336px'
    },
    selectContainer: {
        display: 'flex',
        flexDirection: 'row',
        gap: '1rem',
        alignItems: 'center',
        marginBottom: '.5rem',
        width: '100%'
    },
    dateRangeContainer: {
        display: 'flex',
        flexDirection: 'row',
        gap: '1rem',
        alignItems: 'center',
        marginBottom: '.5rem'
    },
    inputContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
        alignItems: 'start',
        marginBottom: '.5rem'
    },
    dateRange: {
        width: '240px'
    },
    horizontalLine: {
        width: '100%',
        height: '1px',
        backgroundColor: 'var(--color-neutral-200)',
        margin: '0 1rem'
    },
    editableColumnsTitleContainer: {
        display: 'flex',
        justifyContent: 'center',
        marginBottom: '.5rem',
        width: '100%'
    },
    quickDateDisplay: {
        width: '120px'
    },
    quickDateInput: {
        width: '120px'
    },
    quickDateTooltip: {
        backgroundColor: 'var(--color-neutral-500)',
        color: 'var(--color-neutral-0)',
        padding: '10px',
        borderRadius: '5px',
        fontSize: '12px',
        fontWeight: 'bold'
    },
    editableColumnGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        gap: '1rem',
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        justifyItems: 'center'
    }
}))
const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
        ...theme.tooltip
    },
}))(Tooltip);

export const CustomTooltip = (props) => {
    const { text, style } = props
    return (
        <div style={style}>
            <span>{text}</span>
        </div>
    )
}
const standardQuickDates = new Set(options.map(o => o.value))
const getQuickDateLabel = (quickDate) => {
    if (quickDate && !standardQuickDates.has(quickDate)) {
        return 'Custom'
    }
    return options.find((o) => o.value === quickDate)?.label
}
const columnDataRangeRow = (column, onChange, options) => {
    const { getVariable } = useVariables()
    const quickDate = getVariable('quickDate') || 'day'
    return (
        <div className='flex flex-col w-full' key={column.column}>
            <SydLabel className='ml-4' label={column.headerName} />
            <SydSelect style={{ width: '100%' }} minWidth='0' size='sm' value={column.dateRange || quickDate} options={options} onChange={(value) => {
                const code = options.find((o) => o.value === value.target.value)?.code
                onChange(column.column, value.target.value, code)
            }} />
        </div>
    )
}
//get labels from options that are in availableDateRanges
const getQuickDateLabels = (availableDateRanges) => {
    return options.filter((option) => availableDateRanges.includes(option.value)).map((option) => ({ label: option.label, value: option.value }))
}
export const AdditionalDateConfigContent = ({ onClose, onAdditionalDateSave, editableColumns, tooltipStyle, availableDateRanges }) => {
    const quickDateOptions = availableDateRanges.length > 0 ? getQuickDateLabels(availableDateRanges) : options
    const [editableColumnsState, setEditableColumnsState] = useState(editableColumns?.editableColumns ? editableColumns.editableColumns : [])
    const classes = useStyles()
    const { getVariable } = useVariables()
    const quickDate = getVariable('quickDate') || 'day'
    const [dateRange1, setDateRange1] = useState(editableColumns?.dateRange1 ? editableColumns.dateRange1 : quickDate)
    const [dateRange2, setDateRange2] = useState(editableColumns?.dateRange2 ? editableColumns.dateRange2 : quickDate)
    const setDefaults = () => {
        setEditableColumnsState(editableColumns?.editableColumns ? editableColumns.editableColumns : [])
    }
    const closeModal = () => {
        onClose()
    }

    const saveDates = () => {
        onAdditionalDateSave({editableColumns: editableColumnsState, dateRange1, dateRange2})
        onClose()
    }
    const changeDateRange = (column, dateRange, value) => {
        const newList = editableColumnsState.map((c) => c.column === column ? { ...c, dateRange: dateRange, value: value } : c)
        setEditableColumnsState(newList)
    }
    const dataRangeListWithQuickDate = [{ label: quickDate, value: "qd" }, {label: dateRange1, value: "dr1"}, {label: dateRange2, value: "dr2"}]
    const quickDateValues = dataRangeListWithQuickDate.map((option) => {
        return {
            label: quickDateOptions.find((o) => o.value === option.label)?.label || option.label,
            value: option.value,
            code: option.label
        }
    })
    return (
        <div className={classes.container}>
            <div className={classes.inputContainer}>
                <div className={classes.dateRangeContainer}>
                    <div className={classes.quickDateDisplay}>
                        <SydLabel label='Quick Date' className='text-center' />
                        <HtmlTooltip title={<CustomTooltip text={'This is set via the  Quick Date Picker on the main page'} style={tooltipStyle} />}>
                            <div>
                                <SydInput minWidth='0' size='sm' disabled value={getQuickDateLabel(quickDate)} className={classes.quickDateInput} />
                            </div>
                        </HtmlTooltip>
                    </div>
                    <div className={classes.dateRange}>
                        <SydLabel label='Date Range 1' className='text-center' />
                        <SydSelect size='sm' minWidth='0' value={dateRange1} options={quickDateOptions} onChange={(value) => (setDateRange1(value.target.value))} className={classes.selectContainer} />
                    </div>
                    <div className={classes.dateRange}>
                        <SydLabel label='Date Range 2' className='text-center' />
                        <SydSelect size='sm' minWidth='0' value={dateRange2} options={quickDateOptions} onChange={(value) => (setDateRange2(value.target.value))} className={classes.selectContainer} />
                    </div>
                </div>
                <div className={classes.horizontalLine} />
                <div className={classes.editableColumnsTitleContainer}>
                    <span className='font-size-sm font-bold'>Editable Columns</span>
                </div>
                <div className={classes.editableColumnGrid}>
                    {editableColumnsState.map((column) => columnDataRangeRow(column, changeDateRange, quickDateValues))}
                </div>
            </div>
            <div className='flex justify-start w-full gap-2'>
                <div className='flex items-center'>
                    <SydButton onClick={() => { setDefaults({ values: "day", active: false }) }} variant='outline'>
                        <span className='font-size-sm font-bold p-2'>Reset Dates</span>
                    </SydButton>
                </div>
                <div className='flex items-center'>
                    <SydButton onClick={closeModal} variant='outline'>
                        <span className='font-size-sm font-bold p-2'>Cancel Changes</span>
                    </SydButton>
                </div>
                <div className='flex items-center'>
                    <SydButton
                        onClick={saveDates}
                        variant='primary'
                        priority='main'
                    >
                        <span className='font-size-sm font-bold p-2'>Save Changes</span>
                    </SydButton>
                </div>
            </div>
        </div>
    )
}

AdditionalDateConfigContent.propTypes = {
    tooltipStyle: PropTypes.object,
    onClose: PropTypes.func,
    onAdditionalDateSave: PropTypes.func,
    editableColumns: PropTypes.shape({
        editableColumns: PropTypes.arrayOf(PropTypes.shape({
        column: PropTypes.string,
        dateRange: PropTypes.string
    })),
    dateRange1: PropTypes.string,
    dateRange2: PropTypes.string
}),
}
AdditionalDateConfigContent.defaultProps = {
    tooltipStyle: {
        backgroundColor: 'var(--color-neutral-500)',
        color: 'var(--color-neutral-0)',
        padding: '10px',
        borderRadius: '5px',
        fontSize: '12px',
        fontWeight: 'bold'
    },
    onClose: () => { },
    onAdditionalDateSave: () => { },
    editableColumns: {
        editableColumns: [],
        dateRange1: 'day',
        dateRange2: 'day'
    },
}